import {Injectable} from '@angular/core';
import {ApiService} from './server/api.service';
import {GlobalSetting} from '../data/GlobalSetting';

@Injectable({
  providedIn: 'root'
})
export class GlobalSettingsService {
  globalSettings: GlobalSetting[];
  ready: boolean = false;

  constructor(private apiService: ApiService) {
    this.initialize();
  }

  async initialize() {
    await this.waitForApiService();
    this.apiService.applicationApiClient.get<GlobalSetting[]>('GlobalSetting').then((settings) => {
      this.globalSettings = settings;
      this.ready = true;
    });
  }

  async saveSetting(key: OrgSettingsKeys, value: string) {
    await this.apiService.applicationApiClient.post('GlobalSetting', {
      key,
      value
    });
  }

  async getSetting(key: OrgSettingsKeys) {
    if (!this.ready) {
      await this.waitForReady();
    }
    return this.globalSettings.find((s) => s.key === key)?.value;
  }

  async waitForApiService() {
    return new Promise((resolve) => {
      const interval = setInterval(() => {
        if (this.apiService.applicationApiClient) {
          clearInterval(interval);
          resolve(void 0);
        }
      }, 100);
    });
  }

  async waitForReady() {
    return new Promise((resolve) => {
      const interval = setInterval(() => {
        if (this.ready) {
          clearInterval(interval);
          resolve(void 0);
        }
      }, 100);
    });
  }
}


export enum OrgSettingsKeys {
  ORG_PURPOSE = 'AI_Org_Purpose_Desc',
  ORG_WORKERS = 'AI_Org_Workers_Desc',
  ORG_CUSTOMERS = 'AI_Org_Customers_Desc',
  CUST_ACCENT_ENABLED = 'Customization_Accent_Enabled',
  CUST_ACCENT_COLOR = 'Customization_Accent_Color',
  CUST_ACCENT_GRADIENT_0 = 'Customization_Accent_Gradient_0',
  CUST_ACCENT_GRADIENT_1 = 'Customization_Accent_Gradient_1',
}

